import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import _, {isEmpty} from 'lodash';

import ShoppingCartTop from '../components/above/ShoppingCartTop';
import CartSidebar from '../components/sidebar/CartSidebar';
import ViewCartReporter from "../components/analytics/ViewCartReporter";
import NewItemsReporter from "../components/analytics/NewItemsReporter";
import BraintreeTokenFetcher from "../../Checkout/braintree/BraintreeTokenFetcher";
import CatchErrors from "../../Utility/CatchErrors";
import {useSkeletonLoading} from "../../hooks/useSkeletonLoading";
import CheckoutSteps from "../../Checkout/components/general/CheckoutSteps";
import CartCouponTool from "../components/below/CartCouponTool";
import AgentBelowCartToolbar from "../components/agents/AgentBelowCartToolbar";
import CartRefresh from "../components/below/CartRefresh";
import CartItemsHead from "../components/cart_contents/CartItemsHead";
import CartItemsBody from "../components/cart_contents/CartItemsBody";
import {isCheckoutDisabled} from "../../Checkout/logic/checkout";
import CheckoutDisabledNotice from "../../Checkout/components/general/CheckoutDisabledNotice";
import {CartConfigContext} from "../../contexts/CartConfigContext";
import {devAlert} from "../../Utility/logging";
import {useNonEmptyContext} from "../../lib/hooks";
import WholesaleTools from "../components/above/WholesaleTools";

const isDev = (process.env.NODE_ENV == 'development');

// 2023-06 made Braintree-aware; verified shoppingCart and all descendants are camelcased
export default function ShoppingCartUI(props) {

  const cartConfig = useNonEmptyContext(CartConfigContext);  // useContext + an assertation it's not empty

  const ref = useSkeletonLoading();
  const {
    shoppingCart, currentAgent, dispatch, callbacks,
    userCodes
  } = props;

  if (!shoppingCart || !shoppingCart.cartCode) {
    return null;
  }

  let checkoutDisabled = isCheckoutDisabled(cartConfig);

  return <div ref={ref}>
    <CatchErrors label="checkoutSteps">
      <CheckoutSteps current={1} callbacks={{setStep: () => {}}}/>
      <BraintreeTokenFetcher cartCode={shoppingCart.cartCode} dispatch={dispatch}/>
    </CatchErrors>

    <CatchErrors label="cartTop">
      <ShoppingCartTop shoppingCart={shoppingCart} currentAgent={currentAgent} callbacks={callbacks} />
    </CatchErrors>


    <CatchErrors label="wholesaleTools">
      <WholesaleTools
        shoppingCart={shoppingCart}
        callbacks={callbacks}
        userCodes={userCodes}
      />
    </CatchErrors>

    <CatchErrors label="reporting">
      <ViewCartReporter shoppingCart={shoppingCart} />
      <NewItemsReporter shoppingCart={shoppingCart} />
    </CatchErrors>

    <CatchErrors label="viewCart">
      <div className="grid lg:grid-cols-4 gap-4">
        <div className="lg:col-span-3">
          {checkoutDisabled && <CheckoutDisabledNotice cartConfig={cartConfig} /> }

          <ShoppingCartDisplay {...props} />
        </div>
        <CatchErrors label="sidebar"><CartSidebar {...props} /></CatchErrors>
      </div>
    </CatchErrors>

  </div>
}

function ShoppingCartDisplay({...props}) {
  return <div>
    <CatchErrors label="cart-items-table">
      <div id="cart-items-table" className="w-full">
        <CartItemsHead/>
        <CartItemsBody {...props} />
      </div>
    </CatchErrors>

    <CatchErrors label="below-cart-table">
      <div className="grid grid-cols-2"
        style={{gridTemplateColumns: '3fr 1fr'}}>
        <CartCouponTool {...props} />
        <CartRefresh {...props} />
      </div>
    </CatchErrors>

    <div className="clear-me">
      {props.currentAgent && <CatchErrors label="agentBelowCartToolbar">
        <AgentBelowCartToolbar {...props} />
      </CatchErrors>}
    </div>
  </div>
}
